'use es6';
/**
 * This is a general error message, errors in SourceErrorTypes are
 * all specific error messages that fall under TEMPLATE_VALIDATION_FAILED
 *
 * INVALID_CUSTOM_HEAD is a special error type with a different error
 * structure and has to be treated differently.
 */

export const TEMPLATE_VALIDATION_FAILED = 'TEMPLATE_VALIDATION_FAILED';
export const INVALID_CUSTOM_HEAD = 'INVALID_CUSTOM_HEAD';
export const DIFFERENT_FILE_EXTENSION = 'DIFFERENT_FILE_EXTENSION';